import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import themeable from 'zignal-landscape/lib/themeable';
import Save2Icon from 'zignal-landscape/lib/Icon/Save2Icon';
import ToolTip from 'zignal-landscape/lib/ToolTip';

const TableIcon = (props) => {
  const { styles, children, tooltipText, successText, notAuthorized = false, onClick, onMouseLeave = noop, position = 'top' } = props;

  const toolTipNode = successText
    ? (<div className={styles.ToolTipSuccess}>
      <span className={styles.ToolTipIcon}><Save2Icon /></span>
      <span>{<b>{successText}</b>}</span>
    </div>)
    : tooltipText;

  const wrappedIcon = (
    <span
      className={notAuthorized ? styles.TableIconNotAuthorized : styles.TableIconAuthorized}
    >
      {children}
    </span>
  );

  const tooltipComponent = (
    <ToolTip
      position={position}
      tooltipText={toolTipNode}
    >
      {wrappedIcon}
    </ToolTip>
  );

  return (
    <div
      className={styles.TableIcon}
      onMouseLeave={onMouseLeave}
      onClick={notAuthorized ? noop : onClick}
    >
      {notAuthorized || !toolTipNode ? wrappedIcon : tooltipComponent}
    </div>
  );
};

TableIcon.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltipText: PropTypes.node,
  successText: PropTypes.node,
  notAuthorized: PropTypes.bool,
  onMouseLeave: PropTypes.func,
  position: PropTypes.string
};

export default themeable(TableIcon);
